export default function() {
    // Show register form
    if(document.getElementById("register-info")) {
        let registerInfo = document.getElementById("register-info");
        let registerButton = registerInfo.querySelector("#toggle-button");
        let registerForm = document.getElementById("register-form");
    
        registerButton.addEventListener("click", (e) => {
        
            registerInfo.classList.add('is-hidden');
            registerForm.classList.remove('is-hidden');
            e.preventDefault();
        });
    }
}